import { NormalTextInputField } from "@/components";

const HomeTestimonialSectionFormField = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
}) => {
  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-8-testimonial-heading"
        fieldName="home-section-8-testimonial-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-8-testimonial-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Sub Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Sub Heading"
        fieldId="home-section-8-testimonial-sub-heading"
        fieldName="home-section-8-testimonial-sub-heading"
        placeholderText="Sub Heading"
        inputValue={
          stateDetails?.["home-section-8-testimonial-sub-heading"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />
    </>
  );
};

export default HomeTestimonialSectionFormField;
